import { FEATURE_KEYS, type FeatureKey } from '@riverpark/types'

export { FEATURE_KEYS }
export type { FeatureKey }

const FEATURE_KEY_LABELS: Record<FeatureKey, string> = {
  members: 'Members',
  plots: 'Plots & Map',
  billing: 'Billing',
  payments: 'Payments',
  approvals: 'Approvals',
  announcements: 'Announcements',
  governance: 'Governance',
  service_requests: 'Service Requests',
  documents: 'Documents',
}

export function featureKeyLabel(key: FeatureKey): string {
  return FEATURE_KEY_LABELS[key]
}
